export default {
  state() {
    return {
      tradeId: null,
      sellerId: null,
      buyerId: null,
      productTitle: ''
    }
  }
}